<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div
              class="containerIconLeft"
              @click="previous"
              v-if="!mode.pretestMode && !mode.posttestMode && !mode.testmode"
            >
              <font-awesome-icon
                class="IconLeft"
                icon="chevron-left"
                size="1.5"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CRow>
            <CCol col="12">
              <CardFillText
                :question="question"
                :initialAnswer="data"
                :answer="answer"
                :correctANS="correctANS"
                :chapterName="chapterName"
                :chapterDesc="chapterDesc"
                :closePath="closePath"
                :isChangeTemplate="isChangeTemplate"
                @setNext="setNext"
              />
              <CModal
                :title="ModalData.title"
                centered
                :color="ModalData.color"
                :show.sync="ShowAnswerModal"
                :closeOnBackdrop="false"
                class="CmodalShowAnswer"
              >
                <!-- <h5>{{ ModalData.data }}</h5> -->
                <template v-if="ModalData.color === 'danger'">
                  <template v-if="TrueAns.length > 1">
                    <h2>{{ ModalData.data.split('#')[0] }}</h2>
                    <h2 class="fontChinese">{{ TrueAns[0] }}</h2>
                    <h2>Or</h2>
                    <h2 class="fontChinese">{{ TrueAns[1] }}</h2>
                  </template>
                  <template v-else>
                    <h2>{{ ModalData.data.split('#')[0] }}</h2>
                    <h2 class="fontChinese">
                      {{ ModalData.data.split('#')[1] }}
                    </h2>
                  </template>
                </template>
                <template v-else
                  ><h2>{{ ModalData.data.split('#')[0] }}</h2></template
                >
                <br />
                <CRow align-vertical="end" align-horizontal="center">
                  <CButton
                    @click="ModalRoute()"
                    color="success"
                    shape="pill"
                    size="lg"
                    class="ml-2 mr-2 mt-5"
                    >Next</CButton
                  >
                </CRow>
              </CModal>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="1">
          <div class="containerIconRight" @click="nextTo">
            <font-awesome-icon
              class="IconRight"
              icon="chevron-right"
              size="1.5"
            ></font-awesome-icon>
          </div>
        </CCol>
      </CRow>
    </template>
  </div>
</template>
<script>
import CardFillText from './components/CardFillText.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';
import preTestTemplate from '../../../assets/json/pre_test_chn.json';
import testTemplate from '../../../assets/json/test_IAM08';

export default {
  components: {CardFillText, LoadingMDL},
  name: 'IAM08',
  data() {
    return {
      data: [],
      pageCode: `IAM08-` + this.$route.params.id,
      answer: [],
      correctANS: '',
      next: false,
      chapterName: [],
      chapterDesc: [],
      path: '',
      closePath: '',
      previousPath: '',
      question: '',
      SetAnswer: '',
      CheckWidth: window.innerWidth.toString(),
      loaded: false,
      userTemplateData: [],
      nextPath: [],
      TrueAns: [],
      point: 0,
      correctANSLength: [],
      correctANSArray: [],
      canDoItAgain: false,
      ShowAnswerModal: false,
      ModalData: {
        title: '',
        color: '',
        data: '',
      },
      content: {},
      exceptionPath: [
        'IAM08-54',
        'IAM08-55',
        'IAM08-56',
        'IAM08-36',
        'IAM08-37',
        'IAM08-53',
        'IAM08-400',
        'IAM08-401',
        'IAM08-402',
        'IAM08-403',
        'IAM08-404',
      ],
      courseSection: '',
      startTime: '',
      answerResult: null,
      condition: {},
      loading: false,
      v3Score: 0,
      userAnswerStatus: false,
      isChangeTemplate: false,
      nextRoute: null,
    };
  },

  computed: {
    ...mapGetters({
      getTemplateContent: 'template/getTemplateContent',
      getUserTemplate: 'template/getUserTemplate',
      getCheckAnswerResult: 'template/getCheckAnswerResult',
      loadingGetter: 'template/loadingGetter',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];

      if (!template.enable) {
        const pathFormat = template.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      } else {
        this.data = [];
        this.content = template;
        this.nextPath = template.navigate.next.action;

        this.data = Array(template.content.question[0].choices.length);
        this.answer = template.content.question[0].choices;
        this.correctANS =
          template.content.question[0].choices[0].choice.choices.item.data;

        this.correctANSLength = this.correctANS.length;
        this.question = template.content.question[0].title[1].value;
        this.chapterName = template.title;
        this.chapterDesc = template.description;
        this.path = template.navigate.next.action;
        this.closePath = template.navigate.close.action;

        this.previousPath = template.navigate.previous.action;

        this.isChangeTemplate = false;

        this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

        this.loading = false;
      }
    },

    saveContentStatusv4: function (val) {
      // console.log(val, 'IAM08 Watcher Call');
      if (this.nextRoute) {
        this.loading = true;

        const splitPath = this.nextRoute.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    '$route.params.id'() {
      //load data when route changes
      this.onLoadData();
    },
  },

  mounted() {
    this.onLoadData();
  },

  created() {
    this.mode = this.$store.getters['necessary/getMode'];
  },

  beforeDestroy() {},
  methods: {
    onLoadData() {
      this.loading = true;

      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `IAM08-` + this.$route.params.id;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    setNext(status, getAnswer) {
      this.next = status;
      this.SetAnswer = '';
      for (var i = 0; i < getAnswer?.length; i++) {
        if (this.SetAnswer === '') {
          this.SetAnswer = getAnswer[i];
        } else {
          this.SetAnswer = this.SetAnswer + getAnswer[i];
        }
      }
    },
    previous() {
      if (this.previousPath === 'PreTest') {
        alert('You cannot exit while doing pretests.');
      } else {
        this.isChangeTemplate = true;

        let str = this.previousPath.split('-');
        const path = `/v4/${str[0]}/${str[1]}`;
        this.$router.push(path);
        // if (str[0] == 'IAM08') {
        //   let body = {};
        //   body.code = this.courseCode;
        //   body.templateCode = this.previousPath;
        //   // this.$store.dispatch('template/fetchContent', body);
        //   //dispatch here
        // }
      }
    },
    close() {
      let str = this.closePath.split('-');
      const path = `/v4/${str[0]}/${str[1]}`;
      this.$router.push(path);
    },
    nextTo() {
      if (this.SetAnswer.length > 0) {
        this.getCheckResultAnswer();
      } else {
        alert('You must complete the sentence');
      }

      if (event.isTrusted && this.next) {
        let str = this.path.split('-');
        const useTime = this.$helpers.getUseTime();
        // this.userTemplateData.template = this.$helpers.setUserCriteria(
        //   this.userTemplateData.template,
        //   useTime
        // );
        let arr = [];
        arr.push(this.condition);
      }
    },
    ModalRoute() {
      // let str = this.nextPath.split('-');
      // if (str[0] == 'IAM08') {
      //   this.$store.commit('courses/checkIsChangeComponent', true);
      //   this.$store.commit('template/setIsChangeTemplate');
      //   let body = {};
      //   body.code = this.courseCode;
      //   body.templateCode = this.path;
      //   console.log(this.courseCode);

      //   // this.$store.dispatch('template/fetchContent', body);
      //   // this.loading = true;
      // }
      this.isChangeTemplate = true;

      // const path = `/v4/${str[0]}/${str[1]}`;
      // this.$router.push(path);

      this.commitPayloadData(this.nextPath);
      this.ShowAnswerModal = false;
    },
    getCheckResultAnswer() {
      let all_except = ['IAM08-54', 'IAM08-55'];
      let templateCode = `IAM08-` + this.$route.params.id;

      const userAnswer = this.SetAnswer;

      let except = all_except.filter((i) => {
        if (templateCode == i) {
          return i;
        }
      });
      if (except.length == 0) {
        if (userAnswer.length == 0) {
          this.ShowAnswerModal = false;
        } else {
          let isPreTest = preTestTemplate.filter((i) => {
            if (templateCode == i) {
              return i;
            }
          });
          let isTest = testTemplate.filter((i) => {
            if (templateCode == i) {
              return i;
            }
          });

          const correctAnswer =
            this.$store.state.v3.templates.correctAnswers.correctAnswers[0]
              .answer;

          if (isPreTest.length > 0 || isTest.length > 0) {
            //check if ans correct and send Checking status  before relocate to LKT01
            if (correctAnswer === userAnswer) {
              this.userAnswerStatus = true;
              this.v3Score = 1;
              //set State
              this.$store.commit('v3/v3CheckingResultTrue');
            } else {
              this.userAnswerStatus = false;
              this.$store.commit('v3/v3CheckingResultFalse');
            }
            this.ModalRoute();
          } else {
            if (typeof userAnswer === 'string') {
              //check if answer correct for modal show
              if (correctAnswer === userAnswer) {
                this.userAnswerStatus = true;
                this.v3Score = 1;
              } else {
                this.userAnswerStatus = false;
              }

              if (this.userAnswerStatus) {
                this.ModalData = {
                  title: 'Result',
                  color: 'success',
                  data: 'Correct #' + correctAnswer,
                };
              } else {
                if (correctAnswer.length > 1) {
                  this.ModalData = {
                    title: 'Result',
                    color: 'danger',
                    data: 'Incorrect. the correct answer is #' + correctAnswer,
                    // 'or' +
                    // val.correctAnswer[1].correct
                  };
                } else {
                  this.ModalData = {
                    title: 'Result',
                    color: 'danger',
                    data: 'Incorrect. the correct answer is #' + correctAnswer,
                  };
                }
              }
              this.ShowAnswerModal = true;
            } else {
              console.log('ans wrong type');
            }
          }
        }
      } else {
        this.isChangeTemplate = true;
        //check answer before leave
        const correctAnswer =
          this.$store.state.v3.templates.correctAnswers.correctAnswers[0]
            .answer;

        if (correctAnswer === userAnswer) {
          this.$store.commit('v3/v3CheckingResultTrue');
        } else {
          this.$store.commit('v3/v3CheckingResultFalse');
        }
        this.commitPayloadData(this.nextPath);
        // let str = this.nextPath.split('-');
        // const path = `/v4/${str[0]}/${str[1]}`;
        // this.$router.push(path);
      }
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
        score: this.v3Score,
        maxScore: 1,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextRoute = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
        //if not just clear stack
      }
    },
  },
};
</script>

<style></style>
